export const providerTypes = {
    NO_DOMICILED:"No domiciliado",
    LOCAL:"Domiciliado"
}